"use client";

import { amplifyConfig } from "@medimo/core-auth";
import { Amplify } from "aws-amplify";
import type { PropsWithChildren } from "react";
import { clearParentDomainAmplifyCookies } from "./auth/_hooks/amplify-cookie-utils";

// Before Amplify reads the session, so a session planted on a parent domain is never used.
if (typeof document !== "undefined") {
  clearParentDomainAmplifyCookies();
}

Amplify.configure(amplifyConfig, {
  ssr: true,
});

export function AmplifyConfig({ children }: PropsWithChildren) {
  return children;
}
